var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 13",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    transform: "translate(1406 572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    d: "M-1400.9-559c5.1,0,9.3-4.1,9.3-9.2c0-0.1,0-0.1,0-0.2v-0.4c0.6-0.5,1.2-1,1.6-1.7 c-0.6,0.3-1.2,0.4-1.9,0.5c0.7-0.4,1.2-1,1.4-1.8c-0.6,0.4-1.3,0.6-2,0.8c-0.6-0.7-1.5-1.1-2.4-1.1c-1.8,0-3.3,1.5-3.3,3.3 c0,0.2,0,0.5,0.1,0.7c-2.6-0.1-5.1-1.4-6.8-3.5c-0.3,0.5-0.4,1.1-0.4,1.7c0,1.1,0.5,2.1,1.4,2.8c-0.5,0-1.1-0.2-1.5-0.4l0,0 c0,1.6,1.1,2.9,2.7,3.2c-0.3,0.1-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6-0.1c0.4,1.3,1.7,2.3,3.1,2.3c-1.2,0.9-2.6,1.4-4.1,1.4 c-0.3,0-0.5,0-0.8-0.1C-1404.5-559.6-1402.8-559-1400.9-559"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.bfc8e667912d9019eab2824f58989464.svg";
export { ForwardRef as ReactComponent };